<template>
    <div class="tab-general-info">
        <div class="smalltitle blockcont">General Information and Billing Address
            <br/>
            <span style='line-height: 20px !important;display: block;color: #707070;
                  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; font-size: 14px;
                   font-weight: normal'>Please update information below including Billing Provider Address and Billing Provider Taxonomy. This information is needed to generate visit billings. </span>
            <br/>
        </div>
        <div class="blockcont">
            <div class="prolabel"
                 title="Registered name is the legal name used as billing organization that appears in Box 33 of CMS1500 form. This name is not editable and is listed with the organization NPI at the NPPES NPI Registry.">
                Registered Name
            </div>
            <div class="profield"><input type="text" v-model="userInfo.clinicFullName" disabled></div>
            <div class="prolabel" title="Type Of Business">Type Of Business</div>
            <div class="profield"><input type="text" v-model="generalInfo.type_of_business" :disabled="disabledForm">
            </div>
            <div class="prolabel" title="Doing Business As Name">Clinic Name (DBA)</div>
            <div class="profield"><input type="text" v-model="generalInfo.name" :disabled="disabledForm"></div>
            <div class="prolabel">Introduction</div>
            <div class="profield">
                <div v-html="generalInfo.introdution" id="articleContent" :disabled="disabledForm"
                     style="height: 172px; resize: both; overflow: auto;border: 1px solid rgb(225, 225, 225); margin-bottom: 20px;background: #efefef;"
                     class="formattext"></div>
            </div>
            <div class="prolabel">Website</div>
            <div class="profield"><input type="text" v-model="generalInfo.website" :disabled="disabledForm"></div>
            <div class="prolabel">NPI </div>
            <div class="profield"><input type="text" v-model="generalInfo.npi" :disabled="disabledForm"></div>
            <div class="prolabel">Taxonomy Code
                <span style="color: #d9df20;"
                      title="The taxonomy entered here will be used at the EMR to imported into BOX 19 of the CMS 1500 claim form. The choice of clinic or physician taxonomy depends on each insurance."
                      class="light">(?)</span>
            </div>
            <div class="profield">
                <div id="taxonomy_code" v-for="( taxonomy_code) in generalInfo.taxonomy_code">
                    <input style="width: 45%" type="text" v-model="taxonomy_code.code" :disabled="disabledForm"
                           placeholder="Code">
                    <input style="width: 45%" type="text" v-model="taxonomy_code.description" :disabled="disabledForm"
                           placeholder="Description">
                </div>
            </div>

            <div class="prolabel">Tax ID
                <span style="color: #d9df20;" title="This information is needed for BOX 25 at the CMS1500 claim form."
                      class="light">(?)</span>
            </div>
            <div class="profield"><input type="text" v-model="generalInfo.taxid" :disabled="disabledForm"></div>
            <div class="prolabel">Phone Number </div>
            <div class="profield"><input type="text" v-model="generalInfo.phone" name="phone" :disabled="disabledForm">
            </div>
            <div class="prolabel">Fax </div>
            <div class="profield"><input type="text" v-model="generalInfo.fax" name="fax" :disabled="disabledForm">
            </div>
            <div class="prolabel">Billing Address <span style="color: #d9df20;"
                                                        title="This information is entered into BOX 33 at the CMS1500 claim form."
                                                        class="light">(?)</span></div>
            <div class="profield">
                <div class="row">
                    <div class="col-xs-4"><input type="text" placeholder="Street number"
                                                 v-model="generalInfo.billing_info.streetNumber"
                                                 :disabled="disabledForm" maxlength="25">
                    </div>
                    <div class="col-xs-4"><input type="text" placeholder="Street name" :disabled="disabledForm"
                                                 v-model="generalInfo.billing_info.streetName" maxlength="255"></div>
                    <div class="col-xs-4"><input type="text" placeholder="Suite" :disabled="disabledForm"
                                                 v-model="generalInfo.billing_info.suite" maxlength="15"></div>
                </div>
                <div class="row">
                    <div class="col-xs-4">
                        <input title="Type your city" placeholder="City" type="text" :disabled="disabledForm"
                               v-model="generalInfo.billing_info.city" maxlength="100"/>
                    </div>
                    <div class="col-xs-4">
                        <select v-model="generalInfo.billing_info.state" :disabled="disabledForm">
                            <option value="" disabled selected>State</option>
                            <option :value="state.name" v-for="state in STATE">{{state.name}}</option>
                        </select>
                    </div>
                    <div class="col-xs-4"><input type="text" placeholder="Zip Code"
                                                 v-model="generalInfo.billing_info.zipcode" :disabled="disabledForm"
                                                 maxlength="10"></div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="prolabel">Conditions & Services</div>
            <div class="profield">

                <div v-html="generalInfo.conditional" :disabled="disabledForm" id="generalConditional"
                     contenteditable="true"
                     style="height: 172px; resize: both; overflow: auto;border: 1px solid rgb(225, 225, 225); margin-bottom: 20px;background: #efefef;"
                     class="formattext"></div>

            </div>

        </div>
    </div>
</template>

<script>
import config from '../../../../config'
import httpClient from '../../../../client'
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'

export default {
  name: 'TabGeneralInfo',
  components: {},
  props: {
    userInfo: {},
    disabledForm: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      generalInfo: {},
      MARITAL_STATUS: config.MARITAL_STATUS,
      STATE: config.STATE
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    this.getGeneral()
  },
  beforeDestroy () {
  },
  methods: {
    async getGeneral () {
      try {
        let response = await httpClient.get('/users/general-of-clinic/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.generalInfo = response.data.data.generalInfo
          let defaultTaxomy = [
            { code: '207K00000X', description: 'Allergy Immunology' },
            { code: '193200000X', description: 'Multi-specialty Clinic or Group Practice' },
            { code: '193400000X', description: 'Single specialty' }
          ]
          this.generalInfo.taxonomy_code = this.generalInfo.taxonomy_code && this.generalInfo.taxonomy_code.length ? this.generalInfo.taxonomy_code : defaultTaxomy
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
